import React, { useState, useEffect } from "react";
import dayjs from 'dayjs';
import DateRangePicker from "react-bootstrap-daterangepicker";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import FilterModal from "../../../core/modals/filter_modal";
import { dealsData } from "../../../core/data/json/dealsData";
import Table from "../../../core/common/dataTable/index";
import { DealsInterface } from "../../../core/data/interface";
import DealsModal from "../../../core/modals/deals_modal";
import { useDispatch, useSelector } from "react-redux";
import {
  setActivityTogglePopup,
  setActivityTogglePopupTwo,
  setAddTogglePopupTwo,
} from "../../../core/data/redux/commonSlice";
import DefaultEditor from "react-simple-wysiwyg";
import Select, { SingleValue, MultiValue } from "react-select";
import DatePicker from "react-datepicker";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { TagsInput } from "react-tag-input-component";
import {
  optionssymbol,
  priorityList,
  project,
  salestypelist,
  socialMedia,
  tagInputValues,
} from "../../../core/common/selectoption/selectoption";
import CollapseHeader from "../../../core/common/collapse-header";
import { SelectWithImage2 } from "../../../core/common/selectWithImage2";
import { Button, Form, Modal } from "react-bootstrap";
import { getOpportunities, addOpportunity, updateOpportunity, deleteOpportunity, getOpportunityDetail, getAllTags, getTypePipeline, getAccessibilityForOppor, updateAccessibilityForOppor, changeOwner, getOpportunitiesFilter, getAllContacts } from "./dealsAPI";
import { getAllCompanies } from "../companies/companyAPI";
// import { getAllContacts } from "../contacts/contactAPI";
import ResponseModal from "../../../core/modals/response_modal";
import { userList } from "./logcall_api";
import { getTagList } from "../tags/tagAPI";
import { userListByRole } from "../users/userAPI";

interface User {
  id: number;
  username: string;
  uuid: string;
  role: string;
}
interface TagOption {
  value: number;
  label: string;
}
interface Opportunity {
  id: number;
  uuid: string;
  name: string;
  stageId: number;
  stageName: string;
  expectedCloseDate: string;
  ownerUuid: string;
  ownerName: string;
  probability: number;
  status: string;
  amount: number;
  accountId: number;
  tagList: {
    tagId: number;
    name: string;
  }
}

interface OpportunityDetail {
  id: number;
  uuid: string;
  name: string;
  companyName: string;
  owner: string;
  amount: number;
  closeDate: string;
  stage: string;
  type: string;
  leadSource: string;
  tags: Array<{
    tagId: number;
    name: string;
  }>;
  primaryCampaign: string;
  description: string;
  contractId: string | null;
  syncQuoteId: string | null;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  billingStreet: string;
  billingCity: string;
  billingState: string;
  billingZip: string;
  billingCountry: string;
}
interface AddOpportunityForm {
  memberId: number;
  name: string;
  accountId: number;
  stage: string;
  stageId: number;
  status: string;
  amount: number;
  dueDate: string;
  expectedCloseDate: string;
  followUpDate: string;
  owner: string;
  ownerName: string;
  source: string;
  priority: string;
  description: string;
  probability: number;
  tags: Array<{
    tagId: number;
    name: string;
  }>;
  contractId: number | null;
  syncQuoteId: number | null;
  contactIds: number[];
}
interface CompanyOption {
  value: number;
  label: string;
}

interface ContactOption {
  value: number;
  label: string;
}
interface EditOpportunityForm {
  id: number;
  memberId: number;
  name: string;
  accountId: number;
  stageId: number;
  status: string;
  amount: number;
  dueDate: string;
  expectedCloseDate: string;
  followUpDate: string;
  owner: string;
  ownerUuid: string;
  source: string;
  priority: string;
  description: string;
  probability: number;
  tags: Array<{
    tagId: number;
    name: string;
  }>;
}
interface Tag {
  tagId: number;
  name: string;
}
interface OpportunitiesListRequest {
  name?: string | null;
  status?: string | null;
  ownerAlias?: string[] | null;
  tags?: string | null;
  accountId?: number | null;
}
const Deals = () => {
  useEffect(() => {
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "auto";
  }, []);
  const [owner, setOwner] = useState(["Collab"]);
  const [openModal, setOpenModal] = useState(false);
  const [opportunities, setOpportunities] = useState<Opportunity[]>([]);
  const [editingDeal, setEditingDeal] = useState<EditOpportunityForm | null>(null);
  const [selectedRecordIds, setSelectedRecordIds] = useState<number[]>([]);
  const rowSelection = {
    selectedRowKeys: selectedRecordIds,
    onChange: (selectedKeys: any[]) => {
      setSelectedRecordIds(selectedKeys);
    },
  };
  const [formData, setFormData] = useState<OpportunityDetail>({
    id: 0,
    uuid: "",
    name: "",
    companyName: "",
    owner: "",
    amount: 0,
    closeDate: new Date().toISOString(),
    stage: "",
    type: "",
    leadSource: "",
    tags: [] as { tagId: number; name: string }[],
    primaryCampaign: "",
    description: "",
    contractId: null,
    syncQuoteId: null,
    createdBy: "",
    updatedBy: "",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    billingStreet: "",
    billingCity: "",
    billingState: "",
    billingZip: "",
    billingCountry: ""
  });
  const userId = Number(localStorage.getItem("userId"));
  const [formAddData, setFormAddData] = useState<AddOpportunityForm>({
    memberId: userId ?? 0,
    name: "",
    accountId: 0,
    stage: "",
    stageId: 0,
    status: "",
    amount: 0,
    dueDate: new Date().toISOString(),
    expectedCloseDate: new Date().toISOString(),
    followUpDate: new Date().toISOString(),
    owner: "",
    ownerName: "",
    source: "",
    priority: "",
    description: "",
    probability: 0,
    tags: [] as { tagId: number; name: string }[],
    contractId: null,
    syncQuoteId: null,
    contactIds: []
  });
  const [formUpdateData, setFormUpdateData] = useState<EditOpportunityForm>({
    id: 0,
    memberId: userId ?? 0,
    name: "",
    accountId: 0,
    stageId: 0,
    status: "",
    amount: 0,
    dueDate: new Date().toISOString(),
    expectedCloseDate: new Date().toISOString(),
    followUpDate: new Date().toISOString(),
    owner: "",
    ownerUuid: "",
    source: "",
    priority: "",
    description: "",
    probability: 0,
    tags: [] as { tagId: number; name: string }[]
  });

  useEffect(() => {
    const userUuid = localStorage.getItem("userUuid") || "";
    const userName = localStorage.getItem("userName") || "";

    setFormAddData((prevState) => ({
      ...prevState,
      owner: userUuid,
      ownerName: userName
    }));
  }, []);

  const dealsWithKeys = opportunities.map((deal) => ({
    ...deal,
    key: deal.id
  }));

  const handleChange = (e: any) => {
    let { name, value } = e.target;
    if (!name && e.target?.getAttribute) {
      name = e.target.getAttribute("name");
      value = e.target.innerHTML;
    }
    if (!name) return;

    setFormAddData(prevState => ({
      ...prevState,
      [name]: value
    }));

    setEditingDeal(prevState => {
      if (!prevState) return prevState;
      return {
        ...prevState,
        [name]: value,
        memberId: prevState.memberId ?? 0
      };
    });
  };

  const handleTagChange = (selectedOptions: MultiValue<TagOption>) => {
    setEditingDeal(prev => {
      if (!prev) return prev;

      return {
        ...prev,
        tags: selectedOptions
          ? selectedOptions.map(option => ({
            tagId: option.value,
            name: option.label
          }))
          : [],
        id: prev.id ?? 0,
        memberId: prev.memberId ?? 0,
      };
    });
  };
  const [users, setUsers] = useState<User[]>([]);
  const [ownerOptions, setOwnerOptions] = useState<{ value: string; label: string }[]>([]);
  const fetchOwners = async () => {
    try {
      const userTenantId = Number(localStorage.getItem("userTenantId"));
      const response = await userList(userTenantId);
      const fetchedUsers = response.data.data;
      setUsers(fetchedUsers);
      const owners = fetchedUsers.map((user: User) => ({
        value: user.uuid,
        label: user.username,
      }));
      setOwnerOptions(owners);
    } catch (error) {
      console.error("Error fetching owners:", error);
    }
  };
  useEffect(() => {
    fetchOwners();
  }, []);
  const fetchUserByRole = async () => {
    try {
      const userTenantId = Number(localStorage.getItem("userTenantId"));
      const response = await userListByRole(userTenantId, "ACCOUNT_EXECUTIVE	");
      const fetchedUsers = response.data.data;
      setUsers(fetchedUsers);
    } catch (error) {
      console.error("Error fetching owners:", error);
    }
  };
  const calculateProbabilityFromStage = (stageId: number): number => {
    const matchedStage = stages.find(stage => stage.value === stageId);
    if (matchedStage) {
      const order = matchedStage.order ?? 0;
      const probability = (order / stages.length) * 100;
      return parseFloat(probability.toFixed(3));
    }
    return 0;
  };
  const handleSelectChange = (selectedOption: any, field: string) => {
    const value = selectedOption?.value || "";
    setEditingDeal((prevState) => {
      const newState = {
        ...prevState!,
        [field]: value,
      };
      if (field === "stageId") {
        const probability = calculateProbabilityFromStage(Number(value));
        newState.probability = probability;
      }
      return newState;
    });
  };
  const [errorsFilterForm, setErrorsFilterForm] = useState<Record<string, string>>({});
  const validateOpporFilters = () => {
    let newErrors: Record<string, string> = {};

    const isTooLong = (value: string, field: string, max: number = 100) => {
      if (value.trim().length > max) {
        newErrors[field] = `${field[0].toUpperCase() + field.slice(1)} must not exceed ${max} characters.`;
      }
    };

    const onlyDigits = (value: string) => /^\d+$/.test(value);

    const isValidPhone = (value: string) => {
      return /^0\d{9,10}$/.test(value);
    };

    const isValidEmail = (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

    const max50Fields = [
      "name"
    ];

    max50Fields.forEach((field) => {
      const value = (filters as any)[field];
      if (value) {
        if (["phone", "mobile"].includes(field)) {
          if (!isValidPhone(value)) {
            newErrors[field] = `${field[0].toUpperCase() + field.slice(1)} must start with 0 and contain 10–11 digits only.`;
          }
        } else if (field === "email") {
          if (!isValidEmail(value)) {
            newErrors.email = "Invalid email format.";
          } else {
            isTooLong(value, field);
          }
        } else {
          isTooLong(value, field);
        }
      }
    });
    setErrorsFilterForm(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const [errorsAddForm, setErrorsAddForm] = useState<Record<string, string>>({});
  const validateAddForm = () => {
    let newErrors: Record<string, string> = {};

    if (!formAddData.name || formAddData.name.trim() === "") {
      newErrors.name = "Opportunity Name is required.";
    } else if (formAddData.name.length > 100) {
      newErrors.name = "Opportunity Name must be less than 100 characters.";
    }

    if (!formAddData.accountId) newErrors.accountId = "Company is required.";
    if (!formAddData.stageId) newErrors.stageId = "Stage is required.";
    if (formAddData.probability < 0 || formAddData.probability > 100) {
      newErrors.probability = "Probability must be between 0 and 100.";
    }

    if (!formAddData.status) newErrors.status = "Status is required.";
    const today = new Date().toDateString();
    const dueDate = new Date(formAddData.dueDate).toDateString();
    const expectedCloseDate = new Date(formAddData.expectedCloseDate).toDateString();
    const followUpDate = new Date(formAddData.followUpDate).toDateString();

    if (!formAddData.dueDate || !formAddData.followUpDate) {
      newErrors.date = "All dates Follow Up Date, Due Date are required.";
    } else if (
      new Date(followUpDate) < new Date(today) ||
      new Date(expectedCloseDate) < new Date(followUpDate) ||
      new Date(dueDate) < new Date(expectedCloseDate)
    ) {
      newErrors.date = "Invalid date order: Due Date ≥ Expected Close ≥ Follow Up ≥ Today.";
    }
    if (!formAddData.source) newErrors.source = "Source is required.";
    if (!formAddData.priority) newErrors.priority = "Priority is required.";
    if (!formAddData.contactIds || formAddData.contactIds.length === 0) {
      newErrors.contactIds = "At least one contact must be selected.";
    }

    if (formAddData.description?.length > 256) {
      newErrors.description = "Description must be less than 256 characters.";
    }

    setErrorsAddForm(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const [errorsEditForm, setErrorsEditForm] = useState<Record<string, string>>({});
  const validateEditForm = () => {
    let newErrors: Record<string, string> = {};

    if (!editingDeal?.name || editingDeal?.name.trim() === "") {
      newErrors.name = "Opportunity Name is required.";
    } else if (editingDeal?.name?.length > 100) {
      newErrors.name = "Opportunity Name must be less than 100 characters.";
    }
    const probability = editingDeal?.probability ?? 0;
    if (!editingDeal?.accountId) newErrors.accountId = "Company is required.";
    if (!editingDeal?.stageId) newErrors.stageId = "Stage is required.";
    if (probability < 0 || probability > 100) {
      newErrors.probability = "Probability must be between 0 and 100.";
    }

    if (!editingDeal?.status) newErrors.status = "Status is required.";
    const today = new Date();
    const dueDate = editingDeal?.dueDate ? new Date(editingDeal?.dueDate) : null;
    const expectedCloseDate = editingDeal?.expectedCloseDate ? new Date(editingDeal?.expectedCloseDate) : null;
    const followUpDate = editingDeal?.followUpDate ? new Date(editingDeal?.followUpDate) : null;

    if (!dueDate || !expectedCloseDate || !followUpDate) {
      newErrors.date = "All dates (Follow Up, Expected Close, Due Date) are required.";
    } else if (
      followUpDate < today ||
      expectedCloseDate < followUpDate ||
      dueDate < expectedCloseDate
    ) {
      newErrors.date = "Invalid date order: Due Date ≥ Expected Close ≥ Follow Up ≥ Today.";
    }

    if (!editingDeal?.source) newErrors.source = "Source is required.";
    if (!editingDeal?.priority) newErrors.priority = "Priority is required.";
    if ((editingDeal?.description?.length ?? 0) > 256) {
      newErrors.description = "Description must be less than 256 characters.";
    }

    setErrorsEditForm(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const [createdUuid, setCreatedUuid] = useState(null);
  const handleSubmit = async () => {
    if (!validateAddForm()) {
      console.error("Validation failed:", errorsAddForm);
      return;
    }
    try {
      const response = await addOpportunity(formAddData);
      console.log("Success:", response.data);
      const createdDeal = response.data;
      setCreatedUuid(createdDeal.data);
      setOpenModal(true);
      setFormAddData({
        memberId: 0,
        name: "",
        accountId: 0,
        stage: "",
        stageId: 0,
        status: "",
        amount: 0,
        dueDate: new Date().toISOString(),
        expectedCloseDate: new Date().toISOString(),
        followUpDate: new Date().toISOString(),
        owner: "",
        ownerName: "",
        source: "",
        priority: "",
        description: "",
        probability: 0,
        tags: [] as { tagId: number; name: string }[],
        contractId: null,
        syncQuoteId: null,
        contactIds: []
      });

    } catch (error) {
      console.error("Error adding opportunity:", error);
    }
  };
  const addContactId = (contactId: number) => {
    setFormAddData(prev => ({
      ...prev,
      contactsId: [...prev.contactIds, contactId],
    }));
  };
  const removeContactId = (contactId: number) => {
    setFormAddData(prev => ({
      ...prev,
      contactsId: prev.contactIds.filter(id => id !== contactId),
    }));
  };
  const dispatch = useDispatch();
  const activityToggle = useSelector(
    (state: any) => state?.activityTogglePopup
  );
  const addTogglePopupTwo = useSelector(
    (state: any) => state?.addTogglePopupTwo
  );
  const activityToggleTwo = useSelector(
    (state: any) => state?.activityTogglePopupTwo
  );

  const data = dealsData;
  const route = all_routes;
  const initialSettings = {
    endDate: new Date("2020-08-11T12:30:00.000Z"),
    ranges: {
      "Last 30 Days": [
        new Date("2020-07-12T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      "Last 7 Days": [
        new Date("2020-08-04T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      "Last Month": [
        new Date("2020-06-30T18:30:00.000Z"),
        new Date("2020-07-31T18:29:59.999Z"),
      ],
      "This Month": [
        new Date("2020-07-31T18:30:00.000Z"),
        new Date("2020-08-31T18:29:59.999Z"),
      ],
      Today: [
        new Date("2020-08-10T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      Yesterday: [
        new Date("2020-08-09T04:57:17.076Z"),
        new Date("2020-08-09T04:57:17.076Z"),
      ],
    },
    startDate: new Date("2020-08-04T04:57:17.076Z"), // Set "Last 7 Days" as default
    timePicker: false,
  };
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
  };
  const [selectedDate1, setSelectedDate1] = useState<Date | null>(new Date());
  const handleDateChange1 = (date: Date | null) => {
    setSelectedDate1(date);
  };
  const [selectedDate2, setSelectedDate2] = useState<Date | null>(new Date());
  const handleDateChange2 = (date: Date | null) => {
    setSelectedDate2(date);
  };

  const [stars, setStars] = useState<{ [key: number]: boolean }>({});

  const initializeStarsState = () => {
    const starsState: { [key: number]: boolean } = {};
    dealsData.forEach((item, index) => {
      starsState[index] = false;
    });
    setStars(starsState);
  };

  const [pagination, setPagination] = useState({
    totalPages: 1,
    totalElements: 0,
  });
  const [filters, setFilters] = useState<OpportunitiesListRequest>({
    name: null,
    status: null,
    ownerAlias: null,
    tags: null,
    accountId: null,
  });
  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };
  type NumberOption = {
    label: string;
    value: number;
  };

  const handleCompanyChange = (
    selectedOption: SingleValue<NumberOption>
  ) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      accountId: selectedOption?.value ?? null,
    }));
  };

  const handleSelectFilterChange = (
    selectedOption: SingleValue<OptionType>
  ) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      status: selectedOption?.value || null,
    }));
  };

  type OptionType = { value: string; label: string };
  const [selectedOwners, setSelectedOwners] = useState<OptionType[]>([]);
  const handleOwnerChange = (selectedOptions: MultiValue<OptionType>) => {
    setSelectedOwners([...selectedOptions]);
    setFilters((prevFilters) => ({
      ...prevFilters,
      ownerAlias: selectedOptions.map((option: OptionType) => option.value),
    }));
  };
  const applyFilters = async () => {
    if (!validateOpporFilters()) {
      console.error("Validation failed:", errorsFilterForm);
      return;
    }
    try {
      setFilters((prevFilters) => {
        const updatedFilters = { ...prevFilters, pageNo: 0 };
        console.log("Reset pageNo before sending filters:", updatedFilters);
        return updatedFilters;
      });

      const response = await getOpportunitiesFilter({ ...filters, pageNo: 0 });
      setOpportunities(response.data.data.content || []);
    } catch (error) {
      console.error("Error fetching contacts:", error);
    }
  };
  const fetchOpportunities = async (page: number = 0) => {
    try {
      const response = await getOpportunitiesFilter({ ...filters, pageNo: page });
      console.log("API page:", page);
      console.log("API Response:", response.data.data);
      if (response.data && response.data.data && Array.isArray(response.data.data.content)) {
        setOpportunities(response.data.data.content);
        setPagination({
          totalPages: response.data.data.totalPages || 1,
          totalElements: response.data.data.totalElements || 0,
        });
      } else {
        console.error("API response does not contain a valid list:", response.data);
        setOpportunities([]);
      }
    } catch (error) {
      console.error("Error fetching contacts:", error);
      setOpportunities([]);
    }
  };
  useEffect(() => {
    fetchUserByRole();
    fetchOpportunities();
  }, []);

  const handleStarToggle = (index: number) => {
    setStars((prevStars) => ({
      ...prevStars,
      [index]: !prevStars[index],
    }));
  };
  const [showModalAccess, setShowModalAccess] = useState<boolean>(false);
  const [accessType, setAccessType] = useState<"public" | "private" | "isSelected">("public");
  const [selectedPeople, setSelectedPeople] = useState<any[]>([]);
  const [currentId, setCurrentId] = useState<number | null>(null);
  const [tempSelectedUsers, setTempSelectedUsers] = useState<any[]>([]);
  const handleCloseModalAccess = () => {
    setShowModalAccess(false);
    setCurrentId(null);
    setSelectedPeople([]);
    setAccessType("public");
  };

  const handleSetAccessibility = async (id: number) => {
    try {
      const response = await getAccessibilityForOppor(id);
      const accessibilityData = response.data.data;

      setCurrentId(id);

      const isPublic = accessibilityData.public;
      const isPrivate = accessibilityData.private;
      const isSelected = accessibilityData.selected;
      const selected = accessibilityData.accessMembers || [];
      const selectedIds = selected.map((member: any) => member.memberId);

      if (isPublic && selectedIds.length === 0) {
        setAccessType("public");
        setSelectedPeople([]);
        setTempSelectedUsers([]);
      } else if (isPrivate && selectedIds.length === 0) {
        setAccessType("private");
        setSelectedPeople([]);
        setTempSelectedUsers([]);
      } else if (isSelected) {
        setAccessType("isSelected");
        setSelectedPeople(selectedIds);
        setTempSelectedUsers(selectedIds);
      }

      setShowModalAccess(true);
    } catch (error) {
      console.error("Failed to fetch accessibility data:", error);
    }
  };
  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAccessType(e.target.value as "public" | "private" | "isSelected");
  };

  const [showMessageModal, setShowMessageModal] = useState(false);
  const [response, setResponse] = useState<{ status: "success" | "error"; message: string } | null>(null);
  const handleSaveAccessibility = async () => {
    if (!currentId) return;

    let requestData;

    if (accessType === "public") {
      requestData = {
        public: true,
        selectedPeople: []
      };
    } else if (accessType === "private") {
      requestData = {
        public: false,
        selectedPeople: []
      };
    } else if (accessType === "isSelected") {
      requestData = {
        public: false,
        selectedPeople: tempSelectedUsers
      };
    }

    try {
      const response = await updateAccessibilityForOppor(currentId, requestData);
      if (response.status === 200) {
        setShowModalAccess(false);
        setResponse({ status: "success", message: "Change accessibility successfully!" });
      } else {
        setResponse({ status: "error", message: "Failed to save accessibility" });
      }
    } catch (err) {
      console.error("Error saving accessibility:", err);
    } finally {
      setShowMessageModal(true);
    }
  };
  const [selectedOwnerUuid, setSelectedOwnerUuid] = useState<string>();
  const [showChangeOwnerModal, setShowChangeOwnerModal] = useState(false);
  const handleChangeOwner = async () => {
    try {
      if (selectedRecordIds.length === 0) {
        setResponse({ status: "error", message: "Please select at least one lead" });
        return;
      }
      const userId = localStorage.getItem("userId");
      if (!userId) {
        setResponse({ status: "error", message: "User ID not found!" });
        return;
      }
      const response = await changeOwner(selectedRecordIds, selectedOwnerUuid);
      console.log("Change Owner:", response.data);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Change Owner successfully!" });
        setSelectedRecordIds([]);
        setSelectedOwnerUuid("");
        setShowChangeOwnerModal(false);
      }
    } catch (error) {
      console.error("Error change owner", error);
      setResponse({ status: "error", message: "Failed to change owner. Please try again." });
    } finally {
      setShowMessageModal(true);
    }
  };
  const columns = [
    {
      title: "Opportunity Name",
      dataIndex: "name",
      render: (text: any, record: Opportunity) => (
        <div>
          <div>
            <Link to={`/crm/deals-details/${record.uuid}`} className="title-name">
              {text || "N/A"}
            </Link>
          </div>
        </div>
      ),
      sorter: (a: Opportunity, b: Opportunity) => (a.name || "").length - (b.name || "").length,
    },
    {
      title: "Opportunity Value",
      dataIndex: "amount",
      render: (text: any) => text !== null ? `$${text}` : "N/A",
      sorter: (a: Opportunity, b: Opportunity) => (a.amount || 0) - (b.amount || 0),
    },
    {
      title: "Expected Close Date",
      dataIndex: "expectedCloseDate",
      render: (date: string) => dayjs(date).format('YYYY-MM-DD HH:mm:ss'),
      sorter: (a: Opportunity, b: Opportunity) =>
        new Date(a.expectedCloseDate).getTime() - new Date(b.expectedCloseDate).getTime(),
    },
    {
      title: "Owner",
      dataIndex: "ownerName",
      sorter: (a: Opportunity, b: Opportunity) => a.ownerName.length - b.ownerName.length,
    },
    {
      title: "Probability",
      dataIndex: "probability",
      render: (text: any) => text !== null ? `${text}%` : "N/A",
      sorter: (a: Opportunity, b: Opportunity) => (a.probability || 0) - (b.probability || 0),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_: unknown, record: Opportunity) => (
        <div className="dropdown table-action">
          <Link
            to="#"
            className="action-icon"
            data-bs-toggle="dropdown"
            aria-expanded="true"
          >
            <i className="fa fa-ellipsis-v"></i>
          </Link>
          <div
            className="dropdown-menu dropdown-menu-right"
            style={{
              position: "absolute",
              inset: "0px auto auto 0px",
              margin: "0px",
              transform: "translate3d(-99.3333px, 35.3333px, 0px)",
            }}
            data-popper-placement="bottom-start"
          >
            {/* Edit Action */}
            <Link
              className="dropdown-item edit-popup"
              to="#"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvas_edit"
              onClick={() => {
                if (record.uuid) {
                  setErrorsEditForm({});
                  handleEditClick(record.uuid);
                }
              }}

            >
              <i className="ti ti-edit text-blue"></i> Edit
            </Link>

            {/* Delete Action */}
            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete_deal"
              onClick={() => record.id && handleDeleteClick(record.id, record.name)}
            >
              <i className="ti ti-trash text-danger"></i> Delete
            </Link>
            {/* Set Accessibility Action */}
            <Link
              className="dropdown-item"
              to="#"
              onClick={() =>
                record.id &&
                handleSetAccessibility(record.id)
              }
            >
              <i className="ti ti-lock-open text-warning"></i> Set Accessibility
            </Link>
          </div>
        </div>
      ),
    }
  ];
  const [dealToDelete, setDealToDelete] = useState<{ id: number; name: string } | null>(null);
  const handleDeleteClick = (id: number, name: string) => {
    setDealToDelete({ id, name });
  };

  const handleConfirmDelete = () => {
    if (!dealToDelete) return;

    deleteOpportunity(dealToDelete.id)
      .then(() => {
        setOpportunities(prev => prev.filter(deal => deal.id !== dealToDelete.id));
      })
      .catch(error => console.error("Error deleting lead:", error));
  };
  const handleEditClick = async (opportunityUuid: string) => {
    console.log("Lead UUID:", opportunityUuid);
    try {
      const response = await getOpportunityDetail(opportunityUuid);
      console.log("APi response:", response.data.data);
      console.log("All Tags:", allTags);
      console.log("Selected Tags from API:", formUpdateData.tags);
      if (response.status === 200) {
        const data = response.data.data.opportunityDetail;
        setEditingDeal(prev => ({
          ...prev,
          id: data.id,
          memberId: data.id,
          name: data.name,
          accountId: data.accountId,
          stageId: data.stageId,
          status: data.status,
          priority: data.priority,
          amount: data.amount,
          owner: data.owner,
          ownerUuid: data.ownerUuid,
          dueDate: data.dueDate,
          expectedCloseDate: data.expectedCloseDate,
          followUpDate: data.followUpDate,
          description: data.description,
          source: data.source,
          probability: data.probability ?? 0,
          tags: data.tags.map((tag: Tag) => ({
            tagId: tag.tagId,
            name: tag.name
          }))
        }));
        setEditedUuid(response.data.data.opportunityDetail.uuid);
        setFormUpdateData(prev => ({
          ...prev,
          id: data.id,
          name: data.opportunityName,
          accountId: data.accountId,
          stageId: data.stageId,
          status: data.status,
          priority: data.priority,
          amount: data.amount,
          dueDate: data.dueDate,
          owner: data.ownerUuid,
          expectedCloseDate: data.expectedCloseDate,
          followUpDate: data.followUpDate,
          description: data.description,
          source: data.source,
          tags: data.tags.map((tag: Tag) => ({
            tagId: tag.tagId,
            name: tag.name
          }))
        }));
      }
    } catch (error) {
      console.error("Error fetching lead details:", error);
    }
  };
  const [editedUuid, setEditedUuid] = useState(null);
  const [openEditSuccessModal, setOpenEditSuccessModal] = useState(false);
  const handleUpdate = async () => {
    if (!editingDeal?.id) {
      console.error("Error: No valid ID found for update!", editingDeal);
      return;
    }
    if (!validateEditForm()) {
      console.error("Validation failed:", errorsAddForm);
      return;
    }
    try {
      const updatedOppor: EditOpportunityForm = {
        id: editingDeal.id,
        memberId: editingDeal.memberId,
        name: editingDeal.name,
        accountId: editingDeal.accountId,
        stageId: editingDeal.stageId,
        status: editingDeal.status,
        amount: editingDeal.amount,
        dueDate: editingDeal.dueDate,
        expectedCloseDate: editingDeal.expectedCloseDate,
        followUpDate: editingDeal.followUpDate,
        owner: editingDeal.ownerUuid,
        ownerUuid: editingDeal.ownerUuid,
        source: editingDeal.source,
        priority: editingDeal.priority,
        description: editingDeal.description,
        probability: editingDeal.probability,
        tags: editingDeal.tags
      };
      const response = await updateOpportunity(editingDeal.id, updatedOppor);
      if (response.status === 200) {
        console.log("Lead updated successfully");
        setOpenEditSuccessModal(true);
      }
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        setShowMessageModal(true);
      }
    }
  };

  const status = [
    { value: "OPEN", label: "Open" },
    { value: "LOST", label: "Lost" },
    { value: "WON", label: "Won" }
  ];
  const type = [
    { value: "EXISTING_BUSINESS", label: "Existing Business" },
    { value: "NEW_BUSINESS", label: "New Business" },
  ];

  const source = [
    { value: "ADVERTISEMENT", label: "Advertisement" },
    { value: "CUSTOMER_EVENT", label: "Customer Event" },
    { value: "EMPLOYEE_REFERRAL", label: "Employee Referral" },
    { value: "EXTERNAL_REFERRAL", label: "External Referral" },
    { value: "GOOGLE_ADWORDS", label: "Google Adwords" },
    { value: "PARTNER", label: "Partner" },
    { value: "PURCHASED_LIST", label: "Purchased List" },
    { value: "TRADE_SHOW", label: "Trade Show" },
    { value: "WEBINAR", label: "Webinar" },
    { value: "WEBSITE", label: "Website" },
    { value: "OTHER", label: "Other" }
  ];
  const stage = [
    { value: "QUALIFY", label: "Qualify" },
    { value: "MEET_AND_PRESENT", label: "Meet & Present" },
    { value: "PROPOSE", label: "Propose" },
    { value: "NEGOTIATE", label: "Negotiate" },
    { value: "CLOSED_WON", label: "Closed Won" },
    { value: "CLOSED_LOST", label: "Closed Lost" }
  ]
  const stageProbabilityMap: Record<string, number> = {
    QUALIFY: 10,
    MEET_AND_PRESENT: 25,
    PROPOSE: 50,
    NEGOTIATE: 75,
    CLOSED_WON: 100,
    CLOSED_LOST: 0
  };

  const priority = [
    { value: "HIGH", label: "High" },
    { value: "MEDIUM", label: "Medium" },
    { value: "LOW", label: "Low" }
  ];
  const handleStageChange = (selectedOption: { value: number; label: string } | null) => {
    const stageId = selectedOption ? Number(selectedOption.value) : 0;
    const probability = calculateProbabilityFromStage(stageId);
    setFormAddData(prev => ({
      ...prev,
      stageId,
      probability,
    }));
    setFormUpdateData(prev => ({
      ...prev,
      stageId,
      probability,
    }));
  };
  const [companies, setCompanies] = useState<{ label: string; value: number }[]>([]);
  useEffect(() => {
    getAllCompanies()
      .then(response => {
        const companyOptions = response.data.data.map((company: { accountName: string; accountId: number }) => ({
          label: company.accountName,
          value: company.accountId,
        }));
        setCompanies(companyOptions);
      })
      .catch(error => console.error("Error fetching companies:", error));
  }, []);
  const [contacts, setContacts] = useState<{ label: string; value: number }[]>([]);
  // useEffect(() => {
  //   getAllContacts()
  //     .then(response => {
  //       const contactsOption = response.data.data.map((contact: { contactName: string; contactId: number }) => ({
  //         label: contact.contactName,
  //         value: contact.contactId,
  //       }));
  //       setContacts(contactsOption);
  //     })
  //     .catch(error => console.error("Error fetching companies:", error));
  // }, []);
  const handleChooseCompanyChange = async (selectedOption: CompanyOption | null) => {
    setFormAddData(prev => ({
      ...prev,
      accountId: selectedOption?.value || 0,
      contactIds: []
    }));
    try {
      const response = await getAllContacts(selectedOption?.value);
      const contactsOption = response.data.data.map((contact: { contactName: string; contactId: number }) => ({
        label: contact.contactName,
        value: contact.contactId,
      }));
      setContacts(contactsOption);
    } catch (error) {
      console.error("Lỗi khi lấy danh sách liên hệ:", error);
    }
  };
  const [allTags, setAllTags] = useState<{ id: number; name: string }[]>([]);
  const [tagOptions, setTagOptions] = useState<{ label: string; value: number }[]>([]);
  const fetchTags = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const response = await getTagList();
      const tags = response.data.data.map((tag: { id: number; name: string }) => ({
        label: tag.name,
        value: tag.id,
      }));
      setAllTags(response.data.data)
      setTagOptions(tags);
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };
  useEffect(() => {
    fetchTags();
  }, []);

  const [stages, setStages] = useState<{ label: string; value: number; order: number }[]>([]);
  const pipelineType = "OPPORTUNITY";
  useEffect(() => {
    getTypePipeline(pipelineType)
      .then(response => {
        console.log("Pipeline Response:", response.data.data);
        const stageOptions = response.data.data.map((stage: { name: string; id: number, order: number }) => ({
          label: stage.name,
          value: stage.id,
          order: stage.order
        }));
        setStages(stageOptions);
      })
      .catch(error => console.error("Error fetching stages:", error));
  }, [pipelineType]);
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-8">
                    <h4 className="page-title">
                      Opportunities<span className="count-title">{opportunities.length}</span>
                    </h4>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="card">
                <div className="card-header">
                  {/* Search */}
                  <div className="row align-items-center">
                    <div className="col-sm-4">
                    </div>
                    <div className="col-sm-8">
                      <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                        <div className="dropdown me-2">
                        </div>
                        <Link
                          to="#"
                          className="btn btn-primary"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvas_add"
                          onClick={() => setErrorsAddForm({})}
                        >
                          <i className="ti ti-square-rounded-plus me-2" />
                          Add Opportunity
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* /Search */}
                </div>
                <div className="card-body">
                  {/* Filter */}
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                    </div>

                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                      <div className="form-sorts dropdown me-2">
                        <Link
                          to="#"
                          className="btn btn-primary"
                          onClick={() => setShowChangeOwnerModal(true)}
                        >
                          <i className="ti ti-user" />
                          Change Owner
                        </Link>
                      </div>

                      <div className="form-sorts dropdown me-2">
                        <Link
                          to="#"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          <i className="ti ti-filter-share" />
                          Filter
                        </Link>
                        <div className="filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-3">
                          <div className="filter-set-view">
                            <div className="filter-set-head">
                              <h4>
                                <i className="ti ti-filter-share" />
                                Filter
                              </h4>
                            </div>
                            <div className="accordion" id="accordionExample">
                              {/* Opportunity Name */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link to="#" data-bs-toggle="collapse" data-bs-target="#collapseTwo">
                                    Opportunity
                                  </Link>
                                </div>
                                <div className="filter-set-contents accordion-collapse collapse show" id="collapseTwo">
                                  <div className="filter-content-list">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="name"
                                      value={filters?.name || ""}
                                      onChange={handleFilterChange}
                                      placeholder="Enter Opportunity name"
                                    />
                                    {errorsFilterForm.name && <small className="text-danger">{errorsFilterForm.name}</small>}
                                  </div>
                                </div>
                              </div>

                              {/* Company Name */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#company">
                                    Company Name
                                  </Link>
                                </div>
                                <div className="filter-set-contents accordion-collapse collapse" id="company">
                                  <div className="filter-content-list">
                                    <Select
                                      className="select2"
                                      options={companies}
                                      placeholder="Choose Company"
                                      classNamePrefix="react-select"
                                      value={companies.find(option => option.value === filters.accountId)}
                                      onChange={handleCompanyChange}
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Status */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#StatusFilter">
                                    Status
                                  </Link>
                                </div>
                                <div className="filter-set-contents accordion-collapse collapse" id="StatusFilter">
                                  <div className="filter-content-list">
                                    <Select
                                      className="select2"
                                      options={status}
                                      placeholder="Choose"
                                      classNamePrefix="react-select"
                                      name="status"
                                      value={status.find(option => option.value === filters.status)}
                                      onChange={handleSelectFilterChange}
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Owner */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#owner">
                                    Owner
                                  </Link>
                                </div>
                                <div className="filter-set-contents accordion-collapse collapse" id="owner">
                                  <div className="filter-content-list">
                                    <Select
                                      options={ownerOptions}
                                      isMulti
                                      value={selectedOwners}
                                      onChange={handleOwnerChange}
                                      placeholder="Search & Select Owners"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Filter buttons */}
                          <div className="filter-reset-btns">
                            <div className="row">
                              <div className="col-6">
                                <Link
                                  to="#"
                                  className="btn btn-light"
                                  onClick={() => {
                                    setFilters((prevFilters) => ({
                                      ...prevFilters,
                                      name: null,
                                      status: null,
                                      ownerAlias: null,
                                      tags: null,
                                      accountId: null,
                                    }));
                                    setSelectedOwners([]);
                                  }}
                                >
                                  Reset
                                </Link>
                              </div>
                              <div className="col-6">
                                <Link to="#" className="btn btn-primary" onClick={applyFilters}>
                                  Apply Filter
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* View Icons */}
                      <div className="view-icons ms-2">
                        <Link to={route.deals} className="active">
                          <i className="ti ti-list-tree" />
                        </Link>
                        <Link to={route.dealsKanban}>
                          <i className="ti ti-grid-dots" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Filter */}
                {/* Contact List */}
                <div className="table-responsive custom-table">
                  <Table dataSource={dealsWithKeys} columns={columns} rowSelection={rowSelection} />
                </div>
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="datatable-length" />
                  </div>
                  <div className="col-md-6">
                    <div className="datatable-paginate" />
                  </div>
                </div>
                {/* /Contact List */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add New Deals */}
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="offcanvas_add"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Add New Opportunities</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Opportunity Name <span className="text-danger">*</span>
                  </label>
                  <input type="text" className="form-control" name="name" value={formAddData.name} onChange={handleChange} />
                  {errorsAddForm.name && <small className="text-danger">{errorsAddForm.name}</small>}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Company Name <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={companies}
                    placeholder="Choose Company"
                    classNamePrefix="react-select"
                    value={companies.find(option => option.value === formAddData.accountId)}
                    onChange={handleChooseCompanyChange}
                  />
                  {errorsAddForm.accountId && <small className="text-danger">{errorsAddForm.accountId}</small>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Stage <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={stages}
                    placeholder="Choose Stage"
                    classNamePrefix="react-select"
                    value={stages.find(option => option.value === Number(formAddData.stageId)) || null}
                    onChange={handleStageChange}
                  />
                  {errorsAddForm.stageId && <small className="text-danger">{errorsAddForm.stageId}</small>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Probability (%) <span className="text-danger"></span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={formAddData.probability}
                    min={0}
                    max={100}
                    onChange={(e) => {
                      let value = Number(e.target.value);
                      if (value > 100) value = 100;
                      if (value < 0) value = 0;
                      setFormAddData((prev) => ({
                        ...prev,
                        probability: value,
                      }));
                    }}
                  />
                  {errorsAddForm.probability && <small className="text-danger">{errorsAddForm.probability}</small>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={status}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                    name="status"
                    value={status.find(option => option.value === formAddData.status)}
                    onChange={(selectedOption) => setFormAddData(prev => ({ ...prev, status: selectedOption?.value || "" }))}
                  />
                  {errorsAddForm.status && <small className="text-danger">{errorsAddForm.status}</small>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Amount
                  </label>
                  <input type="number" className="form-control" name="amount" value={formAddData.amount} onChange={handleChange} />
                </div>
              </div>
              <div className="col-md-4">
                <div className="mb-3">
                  <label className="col-form-label">
                    Due Date <span className="text-danger">*</span>
                  </label>
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                      className="form-control"
                      selected={new Date(formAddData.dueDate)}
                      onChange={(date) => setFormAddData(prev => ({ ...prev, dueDate: date?.toISOString() || prev.dueDate }))}
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="mb-3">
                  <label className="col-form-label">
                    Expected Close Date
                  </label>
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                      className="form-control"
                      selected={new Date(formAddData.expectedCloseDate)}
                      onChange={(date) => setFormAddData(prev => ({ ...prev, expectedCloseDate: date?.toISOString() || prev.expectedCloseDate }))}
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="mb-3">
                  <label className="col-form-label">
                    Follow Up Date <span className="text-danger">*</span>
                  </label>
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                      className="form-control"
                      selected={new Date(formAddData.followUpDate)}
                      onChange={(date) => setFormAddData(prev => ({ ...prev, followUpDate: date?.toISOString() || prev.followUpDate }))}
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
              </div>
              {errorsAddForm.date && <small className="text-danger">{errorsAddForm.date}</small>}
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Source <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={source}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                    name="source"
                    value={source.find(option => option.value === formAddData.source)}
                    onChange={(selectedOption) => setFormAddData(prev => ({ ...prev, source: selectedOption?.value || "" }))}
                  />
                  {errorsAddForm.source && <small className="text-danger">{errorsAddForm.source}</small>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Priority <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={priority}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                    value={priority.find(option => option.value === formAddData.priority)}
                    onChange={(selectedOption) => setFormAddData(prev => ({ ...prev, priority: selectedOption?.value || "" }))}
                  />
                  {errorsAddForm.priority && <small className="text-danger">{errorsAddForm.priority}</small>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Tags
                  </label>
                  <Select
                    isMulti
                    options={allTags.map(tag => ({
                      value: tag.id,
                      label: tag.name
                    }))}
                    placeholder="Select tags"
                    classNamePrefix="react-select"
                    value={formAddData.tags.map(tag => ({
                      value: tag.tagId,
                      label: tag.name
                    }))}
                    onChange={(selectedOptions) => {
                      console.log("Selected Tags:", selectedOptions);
                      setFormAddData(prev => ({
                        ...prev,
                        tags: selectedOptions ? selectedOptions.map(option => ({
                          tagId: option.value,
                          name: option.label
                        })) : []
                      }));
                    }}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        minHeight: "50px",
                        maxHeight: "none",
                        flexWrap: "wrap",
                        overflowY: "auto",
                      }),
                      valueContainer: (provided) => ({
                        ...provided,
                        flexWrap: "wrap",
                        maxHeight: "150px",
                        overflowY: "auto",
                      }),
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 9999,
                      }),
                    }}
                  />


                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Select Contacts <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={contacts}
                    isMulti
                    placeholder="Choose"
                    classNamePrefix="react-select"
                    value={contacts.filter(option => formAddData.contactIds.includes(option.value))}
                    onChange={(selectedOptions) =>
                      setFormAddData(prev => ({
                        ...prev,
                        contactIds: selectedOptions ? selectedOptions.map(option => option.value) : []
                      }))
                    }
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "auto",
                        height: "auto",
                        flexWrap: "wrap",
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        flexWrap: "wrap",
                        maxHeight: "150px",
                        overflowY: "auto"
                      }),
                      multiValue: (base) => ({
                        ...base,
                        backgroundColor: "#e3f2fd",
                        borderRadius: "5px",
                        padding: "2px 5px",
                      }),
                      multiValueLabel: (base) => ({
                        ...base,
                        fontSize: "14px",
                      }),
                    }}
                  />
                  {errorsAddForm.contactIds && <small className="text-danger">{errorsAddForm.contactIds}</small>}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">Owner</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ownerName"
                    value={formAddData.ownerName}
                    disabled
                  />
                  <input type="hidden" name="owner" value={formAddData.owner} />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Description
                  </label>
                  <DefaultEditor
                    className="summernote"
                    value={formAddData.description}
                    onChange={(e) => setFormAddData(prev => ({ ...prev, description: e.target.value }))}
                  />
                  {errorsAddForm.description && <small className="text-danger">{errorsAddForm.description}</small>}
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-light me-2"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
              >
                Create
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* /Add New Deals */}
      {/* Edit Deals */}
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="offcanvas_edit"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Edit Opportunities</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Opportunity Name <span className="text-danger">*</span>
                  </label>
                  <input type="text" className="form-control" name="name" value={editingDeal?.name} onChange={handleChange} />
                  {errorsEditForm.name && <small className="text-danger">{errorsEditForm.name}</small>}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Company Name <span className="text-danger">*</span>
                  </label>
                  {companies.length > 0 && (
                    <Select
                      className="select2"
                      options={companies}
                      placeholder="Choose Company"
                      classNamePrefix="react-select"
                      value={companies.find(option => option.value === Number(editingDeal?.accountId)) || null}
                      onChange={(selectedOption) => handleSelectChange(selectedOption, "accountId")}
                    />
                  )}
                  {errorsEditForm.accountId && <small className="text-danger">{errorsEditForm.accountId}</small>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Stage <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={stages}
                    placeholder="Choose Stage"
                    classNamePrefix="react-select"
                    value={stages.find(option => option.value === Number(editingDeal?.stageId)) || null}
                    onChange={(selectedOption) => handleSelectChange(selectedOption, "stageId")}
                  />
                  {errorsEditForm.stages && <small className="text-danger">{errorsEditForm.stages}</small>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Probability (%) <span className="text-danger"></span>
                  </label>
                  <input
                    type="number"
                    name="probability"
                    className="form-control"
                    value={editingDeal?.probability ?? ""}
                    min={0}
                    max={100}
                    step="0.001"
                    onChange={handleChange}
                  />
                  {errorsEditForm.probability && <small className="text-danger">{errorsEditForm.probability}</small>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={status}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                    name="status"
                    value={status.find(option => option.value === editingDeal?.status)}
                    onChange={(selectedOption) => handleSelectChange(selectedOption, "status")}
                  />
                  {errorsEditForm.status && <small className="text-danger">{errorsEditForm.status}</small>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Amount
                  </label>
                  <input type="number" className="form-control" name="amount" value={editingDeal?.amount} onChange={handleChange} />
                </div>
              </div>
              <div className="col-md-4">
                <div className="mb-3">
                  <label className="col-form-label">
                    Due Date <span className="text-danger">*</span>
                  </label>
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                      className="form-control"
                      selected={new Date(formUpdateData.dueDate)}
                      onChange={(date) => setFormUpdateData(prev => ({ ...prev, dueDate: date?.toISOString() || prev.dueDate }))}
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="mb-3">
                  <label className="col-form-label">
                    Expected Close Date
                  </label>
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                      className="form-control"
                      selected={new Date(formUpdateData.expectedCloseDate)}
                      onChange={(date) => setFormUpdateData(prev => ({ ...prev, expectedCloseDate: date?.toISOString() || prev.expectedCloseDate }))}
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="mb-3">
                  <label className="col-form-label">
                    Follow Up Date <span className="text-danger">*</span>
                  </label>
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                      className="form-control"
                      selected={new Date(formUpdateData.followUpDate)}
                      onChange={(date) => setFormUpdateData(prev => ({ ...prev, followUpDate: date?.toISOString() || prev.followUpDate }))}
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
              </div>
              {errorsEditForm.date && <small className="text-danger">{errorsEditForm.date}</small>}
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Owner
                  </label>
                  <input type="text" className="form-control" name="owner" value={editingDeal?.owner} readOnly />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Source <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={source}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                    value={source.find(option => option.value === (editingDeal?.source)) || null}
                    onChange={(selectedOption) => handleSelectChange(selectedOption, "source")}
                  />
                  {errorsEditForm.source && <small className="text-danger">{errorsEditForm.source}</small>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Tags
                  </label>
                  <Select
                    isMulti
                    options={allTags.map(tag => ({
                      value: tag.id,
                      label: tag.name
                    }))}
                    value={editingDeal?.tags?.map(tag => ({
                      value: tag.tagId,
                      label: tag.name
                    })) || []}
                    onChange={handleTagChange}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        minHeight: "50px",
                        maxHeight: "auto",
                        overflowY: "auto",
                      }),
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 9999,
                      }),
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Description
                  </label>
                  <DefaultEditor
                    className="summernote"
                    name="description"
                    value={editingDeal?.description}
                    onChange={handleChange}
                  />
                  {errorsEditForm.description && <small className="text-danger">{errorsEditForm.description}</small>}
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-light me-2"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleUpdate}
              >
                Edit
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* /Edit Deals */}
      {/* Delete Deal */}
      <div className="modal fade" id="delete_deal" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Remove Deal?</h4>
                <p className="mb-0">
                  Are you sure you want to remove <br /> deal you selected.
                </p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button
                    data-bs-dismiss="modal"
                    className="btn btn-danger"
                    onClick={handleConfirmDelete}
                  >
                    Yes, Delete {dealToDelete?.name}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Deal */}
      {/* Create Deal */}
      <Modal show={openModal} onHide={() => setOpenModal(false)}>
        <div className="modal-header border-0 m-0 justify-content-end">
          <button
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => setOpenModal(false)}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-body">
          <div className="success-message text-center">
            <div className="success-popup-icon bg-light-blue">
              <i className="ti ti-medal" />
            </div>
            <h3>Deal Created Successfully!!!</h3>
            <p>View the details of deal, created</p>
            <div className="col-lg-12 text-center modal-btn">
              <Link
                to="#"
                className="btn btn-light"
                onClick={() => setOpenModal(false)}
              >
                Cancel
              </Link>
              <Link
                to={`/crm/deals-details/${createdUuid}`}
                onClick={() => {
                  setOpenModal(false);
                }}
                className="btn btn-primary"
              >
                Ok
              </Link>
            </div>
          </div>
        </div>
      </Modal>
      {/* /Create Deal */}
      {/* Edit Lead Success Modal */}
      <Modal show={openEditSuccessModal} onHide={() => setOpenEditSuccessModal(false)}>
        <div className="modal-body">
          <div className="success-message text-center">
            <div className="success-popup-icon bg-light-blue">
              <i className="ti ti-chart-arcs" />
            </div>
            <h3>Opportunity Updated Successfully!!!</h3>
            <div className="col-lg-12 text-center modal-btn">
              <Link
                to={`/crm/deals-details/${editedUuid}`}
                onClick={() => {
                  setOpenEditSuccessModal(false);
                }}
                className="btn btn-primary"
              >
                Ok
              </Link>
            </div>
          </div>
        </div>
      </Modal>
      {/* Edit Lead Success Modal */}
      {/* Add New Pipeline */}
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="offcanvas_pipeline"
      >
        <div className="offcanvas-header border-bottom">
          <h4>Add New Pipeline</h4>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form >
            <div>
              <div className="mb-3">
                <label className="col-form-label">
                  Pipeline Name <span className="text-danger">*</span>
                </label>
                <input className="form-control" type="text" />
              </div>
              <div className="mb-3">
                <div className="pipe-title d-flex align-items-center justify-content-between">
                  <h5 className="form-title">Pipeline Stages</h5>
                  <Link
                    to="#"
                    className="add-stage"
                    data-bs-toggle="modal"
                    data-bs-target="#add_stage"
                  >
                    <i className="ti ti-square-rounded-plus" />
                    Add New
                  </Link>
                </div>
                <div className="pipeline-listing">
                  <div className="pipeline-item">
                    <p>
                      <i className="ti ti-grip-vertical" /> Inpipeline
                    </p>
                    <div className="action-pipeline">
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_stage"
                      >
                        <i className="ti ti-edit text-blue" />
                        Edit
                      </Link>
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#delete_stage"
                      >
                        <i className="ti ti-trash text-danger" />
                        Delete
                      </Link>
                    </div>
                  </div>
                  <div className="pipeline-item">
                    <p>
                      <i className="ti ti-grip-vertical" /> Follow Up
                    </p>
                    <div className="action-pipeline">
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_stage"
                      >
                        <i className="ti ti-edit text-blue" />
                        Edit
                      </Link>
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#delete_stage"
                      >
                        <i className="ti ti-trash text-danger" />
                        Delete
                      </Link>
                    </div>
                  </div>
                  <div className="pipeline-item">
                    <p>
                      <i className="ti ti-grip-vertical" /> Schedule Service
                    </p>
                    <div className="action-pipeline">
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_stage"
                      >
                        <i className="ti ti-edit text-blue" />
                        Edit
                      </Link>
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#delete_stage"
                      >
                        <i className="ti ti-trash text-danger" />
                        Delete
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <h5 className="form-title">Access</h5>
                <div className="d-flex flex-wrap access-item nav">
                  <div
                    className="radio-btn"
                    data-bs-toggle="tab"
                    data-bs-target="#all"
                  >
                    <input
                      type="radio"
                      className="status-radio"
                      id="all"
                      name="status"
                      defaultChecked
                    />
                    <label htmlFor="all">All</label>
                  </div>
                  <div
                    className="radio-btn"
                    data-bs-toggle="tab"
                    data-bs-target="#select-person"
                  >
                    <input
                      type="radio"
                      className="status-radio"
                      id="select"
                      name="status"
                    />
                    <label htmlFor="select">Select Person</label>
                  </div>
                </div>
                <div className="tab-content mb-3">
                  <div className="tab-pane fade" id="select-person">
                    <div className="access-wrapper">
                      <div className="access-view">
                        <div className="access-img">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-21.jpg"
                            alt="Image"
                          />
                          Vaughan
                        </div>
                        <Link to="#">Remove</Link>
                      </div>
                      <div className="access-view">
                        <div className="access-img">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-01.jpg"
                            alt="Image"
                          />
                          Jessica
                        </div>
                        <Link to="#">Remove</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-light me-2"
              >
                Cancel
              </button>
              <button type="button" className="btn btn-primary">
                Create
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* /Add New Pipeline */}
      {/* Delete Stage */}
      <div className="modal fade" id="delete_stage" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Remove Stage?</h4>
                <p className="mb-0">
                  Are you sure you want to remove <br /> stage you selected.
                </p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link to={route.deals} data-bs-dismiss="modal" className="btn btn-danger">
                    Yes, Delete it
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Stage */}
      {/* Add New Stage */}
      <div className="modal custom-modal fade" id="add_stage" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add New Stage</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form >
                <div className="mb-3">
                  <label className="col-form-label">Stage Name *</label>
                  <input type="text" className="form-control" />
                </div>
                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button type="button" data-bs-dismiss="modal" className="btn btn-danger">
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add New Stage */}
      {/* Edit Stage */}
      <div className="modal custom-modal fade" id="edit_stage" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Stage</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form >
                <div className="mb-3">
                  <label className="col-form-label">Stage Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue="Inpipeline"
                  />
                </div>
                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button type="button" data-bs-dismiss="modal" className="btn btn-danger">
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Stage */}
      {/* Add New View */}
      <div className="modal custom-modal fade" id="save_view" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add New View</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form >
                <div className="mb-3">
                  <label className="col-form-label">View Name</label>
                  <input type="text" className="form-control" />
                </div>
                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button type="button" data-bs-dismiss="modal" className="btn btn-danger">
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add New View */}
      {/*Change Owner Modal */}
      {
        showChangeOwnerModal && (
          <div className="modal custom-modal fade show d-block" tabIndex={-1} role="dialog">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Change Owner</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowChangeOwnerModal(false)}
                    aria-label="Close"
                  ><i className="ti ti-x" /></button>
                </div>

                <div className="modal-body">
                  <Select
                    className="select2"
                    options={ownerOptions}
                    classNamePrefix="react-select"
                    value={ownerOptions.find((option) => option.value === selectedOwnerUuid) || null}
                    onChange={(selectedOption) => {
                      setSelectedOwnerUuid(selectedOption?.value);
                    }}
                    placeholder="Select Owner"
                  />
                </div>

                <div className="modal-footer">
                  <button type="button" className="btn btn-light" onClick={() => setShowChangeOwnerModal(false)}>Cancel</button>
                  <button type="button" className="btn btn-primary" onClick={handleChangeOwner}>Change</button>
                </div>
                <ResponseModal
                  show={showMessageModal}
                  onClose={() => setShowMessageModal(false)}
                  response={response}
                />
              </div>
            </div>
          </div>
        )
      }
      {/* Access Modal */}
      <Modal show={showModalAccess} onHide={handleCloseModalAccess} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Set Accessibility</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Radio buttons */}
            <Form.Check
              type="radio"
              label="Public"
              value="public"
              name="access"
              checked={accessType === "public"}
              onChange={handleRadioChange}
            />
            <Form.Check
              type="radio"
              label="Private"
              value="private"
              name="access"
              checked={accessType === "private"}
              onChange={handleRadioChange}
            />
            <Form.Check
              type="radio"
              label="Selected People"
              value="isSelected"
              name="access"
              checked={accessType === "isSelected"}
              onChange={() => {
                setAccessType("isSelected");
                setTempSelectedUsers(selectedPeople);
              }}
            />

            {accessType === "isSelected" && (
              <>
                <div className="mb-3 mt-3">
                  <label className="col-form-label">Select Users</label>
                  <Select
                    isMulti
                    name="users"
                    options={users.map(user => ({
                      value: user.id,
                      label: `${user.username} - ${user.role}`
                    }))}
                    value={users
                      .filter(user => tempSelectedUsers.includes(user.id))
                      .map(user => ({
                        value: user.id,
                        label: `${user.username} - ${user.role}`
                      }))}
                    onChange={(selectedOptions) => {
                      setTempSelectedUsers(selectedOptions.map(opt => opt.value));
                    }}
                    isSearchable={true}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        maxWidth: '100%',
                        overflow: 'hidden'
                      }),
                      multiValue: (provided) => ({
                        ...provided,
                        whiteSpace: 'nowrap'
                      }),
                      multiValueLabel: (provided) => ({
                        ...provided,
                        maxWidth: '200px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      })
                    }}
                  />
                </div>

                {tempSelectedUsers.length > 0 && (
                  <div className="mt-2 p-2 border rounded bg-light">
                    <strong>Selected Users:</strong>
                    <ul className="mb-0 ps-3">
                      {tempSelectedUsers.map(userId => {
                        const user = users.find(u => u.id === userId);
                        return user ? (
                          <li key={user.id}>
                            {user.username} - {user.role}
                          </li>
                        ) : null;
                      })}
                    </ul>
                  </div>
                )}
              </>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModalAccess}>
            Close
          </Button>
          <Button variant="primary" onClick={() => {
            setSelectedPeople(tempSelectedUsers);
            handleSaveAccessibility();
          }}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>


      <ResponseModal
        show={showMessageModal}
        onClose={() => setShowMessageModal(false)}
        response={response}
      />
    </>

  );
};

export default Deals;
